import { Avatar } from "@admin/components/atoms/Avatar";
import { CompanyLocation } from "@enos-monorepo/lib";

import { Period } from "../../models/period";

interface LocationInfoProps {
  selectedLocation?: CompanyLocation;
  selectedPeriod?: Period;
}

export function LocationInfo({ selectedLocation }: LocationInfoProps) {
  if (selectedLocation) {
    return (
      <div className="flex flex-row gap-[25px]">
        <Avatar
          src={selectedLocation.avatarPhoto}
          size="xl"
          alt={selectedLocation.name}
        />
        <div className="flex flex-col py-2.5  justify-center">
          <span className="flex flex-col  gap-2.5 justify-center">
            <span className="text-[18px]  font-semibold">
              {selectedLocation.name}
            </span>
          </span>
          <div className="flex flex-col gap-2.5 justify-center">
            <span className="flex flex-row gap-[5px] items-center">
              <i className="ki-filled ki-geolocation"></i>
              <span className="text-[#A1A5B7]">{selectedLocation.address}</span>
            </span>
          </div>
        </div>
      </div>
    );
  }

  return null;
}
